import TemplateList from '../../TemplateList';

/** Temporary alias for the <TemplateList />, until it's fully integrated under the Logic section */
export const ForEachBlock = TemplateList;
